module.exports = __webpack_public_path__ + "img/text.c9d8bb48.png";